import script from "./CompetitionStandingsFilter.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompetitionStandingsFilter.vue?vue&type=script&lang=ts&setup=true"

import "./CompetitionStandingsFilter.vue?vue&type=style&index=0&id=437783a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-437783a6"]])

export default __exports__